import { render, staticRenderFns } from "./complianceNew.vue?vue&type=template&id=8bdff874&"
import script from "./complianceNew.vue?vue&type=script&lang=js&"
export * from "./complianceNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports